var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkpapersFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1875 1.96875C0.1875 1.36469 0.677189 0.875 1.28125 0.875H3.25C4.45812 0.875 5.4375 1.85438 5.4375 3.0625V4.15625C5.4375 4.76031 5.92719 5.25 6.53125 5.25H7.625C7.91961 5.25 8.20061 5.30824 8.45713 5.41383L5.05315 8.81781L2.88166 6.64632C2.7689 6.53356 2.63025 6.47243 2.47222 6.47243C2.3142 6.47243 2.17555 6.53356 2.06278 6.64632C1.94736 6.76174 1.88889 6.90617 1.88889 7.07002C1.88889 7.23387 1.94736 7.3783 2.06278 7.49372L4.64371 10.0746C4.7017 10.1326 4.76634 10.18 4.83852 10.2089C4.90641 10.2361 4.97858 10.2485 5.05315 10.2485C5.12772 10.2485 5.19988 10.2361 5.26777 10.2089C5.33995 10.18 5.4046 10.1326 5.46259 10.0746L9.39095 6.14629C9.656 6.50817 9.8125 6.95456 9.8125 7.4375V12.0312C9.8125 12.6353 9.32281 13.125 8.71875 13.125H1.28125C0.677188 13.125 0.1875 12.6353 0.1875 12.0312V1.96875Z",
    fill: "#3730A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 3.0625C6.3125 2.29655 6.03131 1.59628 5.56653 1.05928C7.54924 1.5772 9.1103 3.13826 9.62822 5.12097C9.09122 4.65619 8.39095 4.375 7.625 4.375H6.53125C6.41044 4.375 6.3125 4.27706 6.3125 4.15625V3.0625Z",
    fill: "#3730A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkpapersFill);
export default __webpack_public_path__ + "static/media/workpapers-fill.41d941db29cf3b50236f37ac3ae20799.svg";
export { ForwardRef as ReactComponent };